export default __webpack_public_path__ + "static/media/head_1_female.af36411b.png";